
var preact = require('preact');
var hooks = require('preact/hooks');
module.exports = {"attributes":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"},"content":"<path d=\"M15.643 12.166l4.757 4.741-4.76 4.692-1.168-1.158 2.758-2.72H6.637c-1.349 0-2.447-1.078-2.447-2.403v-1.676h1.655v1.676a.78.78 0 00.792.768h10.609l-2.777-2.768 1.174-1.152zm-6.114-1.485l-1.173 1.152L3.6 7.092 8.36 2.4l1.167 1.157-2.759 2.721h10.594c1.348 0 2.446 1.078 2.446 2.403v1.69h-1.654v-1.69a.78.78 0 00-.792-.768H6.754l2.775 2.768z\" fill=\"currentColor\" fill-rule=\"evenodd\"/>"}
var attributes = module.exports.attributes;
var content = module.exports.content;

module.exports = function (props) {
	var ref = hooks.useRef();

	hooks.useEffect(function () {
		var div = document.createElement('div');
		div.innerHTML = '<svg>' + content + '</svg>';

		var source = div.firstChild;
		var dest = ref.current;

		while (source.firstChild) {
			dest.appendChild(source.firstChild);
		}
	}, []);

	return preact.h('svg', Object.assign({ ref: ref }, attributes, props));
};
